<template>
  <div
    class="max-w-[560px] w-full text-left py-[40px] px-[30px] md:p-[40px] bg-white rounded-lg border-[2px] border-blue-5 otivo-drop-shadow">
    <h5 class="headline-5 bold">Before you start.</h5>
    <div class="mt-5 ml-4">
      <p class="button-1">Please have these details ready</p>
      <ul class="list-disc list-outside ml-5 text-grey-1 paragraph-1 mt-2.5">
        <li class="pl-2">Member ID (OIN) number</li>
        <li class="pl-2">Account number</li>
        <li class="pl-2">Balance</li>
        <li class="pl-2">Current investment holdings</li>
      </ul>
      <p class="paragraph-1">
        You can access these details online by logging into FirstNet or the CFS app.
      </p>
    </div>
    <div class="my-5 ml-4">
      <p class="button-1">Please confirm</p>
      <ul class="list-disc list-outside ml-5 text-grey-1 paragraph-1 mt-2.5">
        <li class="pl-2">
          I have a FirstChoice Wholesale Personal Super, FirstChoice Wholesale Pension, or
          FirstChoice Employer account.
        </li>
        <li class="pl-2">I do not have a financial adviser.</li>
        <li class="pl-2">My account does not have an insurance claim in progress.</li>
        <li class="pl-2">
          I understand that Otivo does not provide advice on FirstChoice Wholesale Allocated
          Pre-Retirement Pension (TTR).
        </li>
      </ul>
    </div>

    <div class="w-full md:w-fit flex flex-col gap-4">
      <OtivoButton class="w-full" @click="handleAccept"> Proceed </OtivoButton>

      <OtivoButton colour="white" @click="handleReject"> Do not proceed </OtivoButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import OtivoButton from '@/components/OtivoButton.vue'
import { useSessionStore } from '@/store/pinia/SessionStore'
import { useRouter } from 'vue-router'

const sessionStore = useSessionStore()
const router = useRouter()

const handleAccept = () => {
  router.push({ name: 'UserDetailsForm' })
}

const handleReject = () => {
  sessionStore.logout()
}
</script>
